export const generateJobId = () => {
  const chars = 'ABCDEF0123456789';
  let out = 'PR-';
  for (let i = 0; i < 8; i += 1) {
    out += chars[Math.floor(Math.random() * chars.length)];
  }
  return out;
};
